<template>
  <div v-if="shouldRender" class="py-1">
    <file-item-card
      :file-name="decodedFileName"
      :extension="extension"
      :icon-color-class="getFileIconColor(fileType, getFileExtension(url))"
    >
      <template #action>
        <button
          type="button"
          :title="$t('CONVERSATION.DOWNLOAD')"
          class="w-11 h-11 flex items-center justify-center button-naked shrink-0 transition-colors"
          @click="showGallery = true"
        >
          <span class="material-symbols-outlined text-[22px]">download</span>
        </button>
      </template>
    </file-item-card>
    <gallery-view
      v-if="showGallery"
      :show.sync="showGallery"
      :attachment="{ data_url: url, file_type: fileType }"
      @close="showGallery = false"
    />
  </div>
</template>

<script>
import FileItemCard from 'dashboard/components/widgets/FileItemCard.vue';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
import { getFileExtension, getFileIconColor } from 'dashboard/helper/fileUtils';

export default {
  components: { FileItemCard, GalleryView },
  props: {
    url: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showGallery: false,
    };
  },
  computed: {
    shouldRender() {
      return this.url.length > 0;
    },
    decodedFileName() {
      if (this.url) {
        const filename = this.url.substring(this.url.lastIndexOf('/') + 1);
        return decodeURI(filename) || this.$t('CONVERSATION.UNKNOWN_FILE_TYPE');
      }
      return this.$t('CONVERSATION.UNKNOWN_FILE_TYPE');
    },
    extension() {
      const parts = this.decodedFileName.split('.');
      return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : '';
    },
  },
  methods: {
    getFileExtension,
    getFileIconColor,
  },
};
</script>
